import { useTranslation } from 'react-i18next';
import { lobbySocket } from '../lib/lobbySocket';
import { useLobby } from '../store/lobby';
import { Avatar } from './ui';

/** Incoming duel challenge with a visible countdown; accept/decline go straight to the server. */
export function ChallengePopup() {
  const { t } = useTranslation();
  const challenges = useLobby((s) => s.challenges);
  const remove = useLobby((s) => s.removeChallenge);
  const c = challenges[0];
  if (!c) return null;
  const left = Math.max(0, c.expiresAt - Date.now());
  if (left === 0) {
    setTimeout(() => remove(c.id), 0);
    return null;
  }
  const respond = (accept: boolean) => {
    lobbySocket.send({ t: 'challenge.respond', challengeId: c.id, accept });
    remove(c.id);
  };
  return (
    <div className="challenge-pop card" role="alertdialog" aria-label={t('challenge.incoming', { name: c.from.displayName })}>
      <div className="row">
        <Avatar avatar={c.from.avatar} avatarUrl={c.from.avatarUrl} name={c.from.displayName} size={44} />
        <div className="grow">
          <strong>{t('challenge.incoming', { name: c.from.displayName })}</strong>
          <div className="faint">{t('modes.duel')} · {t('modes.duelDesc')}</div>
        </div>
      </div>
      <div className="timer-bar mt" key={c.id}>
        <div style={{ animationDuration: `${left}ms` }} onAnimationEnd={() => remove(c.id)} />
      </div>
      <div className="row mt">
        <button className="btn ghost grow" onClick={() => respond(false)}>{t('challenge.decline')}</button>
        <button className="btn primary grow" onClick={() => respond(true)}>{t('challenge.accept')}</button>
      </div>
    </div>
  );
}

/** Incoming party invite from a friend (shown when no challenge is waiting). */
export function PartyInvitePopup() {
  const { t } = useTranslation();
  const invites = useLobby((s) => s.partyInvites);
  const challenges = useLobby((s) => s.challenges);
  const remove = useLobby((s) => s.removePartyInvite);
  const inv = invites[0];
  if (!inv || challenges.length) return null;
  const left = Math.max(0, inv.expiresAt - Date.now());
  if (left === 0) {
    setTimeout(() => remove(inv.partyId), 0);
    return null;
  }
  const respond = (accept: boolean) => {
    lobbySocket.send({ t: 'party.respond', partyId: inv.partyId, accept });
    remove(inv.partyId);
  };
  return (
    <div className="challenge-pop card" role="alertdialog" aria-label={t('party.invitedBy', { name: inv.from.displayName })}>
      <div className="row">
        <Avatar avatar={inv.from.avatar} avatarUrl={inv.from.avatarUrl} name={inv.from.displayName} size={44} />
        <div className="grow">
          <strong>{t('party.invitedBy', { name: inv.from.displayName })}</strong>
          <div className="faint">{t('party.inviteDesc')}</div>
        </div>
      </div>
      <div className="timer-bar mt" key={inv.partyId}>
        <div style={{ animationDuration: `${left}ms` }} onAnimationEnd={() => remove(inv.partyId)} />
      </div>
      <div className="row mt">
        <button className="btn ghost grow" onClick={() => respond(false)}>{t('challenge.decline')}</button>
        <button className="btn primary grow" onClick={() => respond(true)}>{t('party.join')}</button>
      </div>
    </div>
  );
}
